import { render, staticRenderFns } from "./sceltaDdt.vue?vue&type=template&id=2e08d8e0"
import script from "./sceltaDdt.vue?vue&type=script&lang=js"
export * from "./sceltaDdt.vue?vue&type=script&lang=js"
import style0 from "./sceltaDdt.vue?vue&type=style&index=0&id=2e08d8e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports